import React from "react";
import "../../App.css";

const SignUp = () => {
  return <h1 className="sign-upa">SIGN UP</h1>;
};

export default SignUp;
